import React from 'react'
import Modal from '../common/Modal'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'

export default function PinHelpModal ({ id, trigger }) {
  return <Modal
    id={id}
    trigger={trigger}
    closeIcon
    closeOnDimmerClick
  >
    <Grid divided='vertically'>
      <GridRow>
        <GridColumn width={16}>
          <h3>Pin not working?</h3>
        </GridColumn>
      </GridRow>
      <GridRow>
        <GridColumn width={16}>
          <p>If your PIN isn&apos;t working or you can&apos;t find it, you can either contact your benefits
            administrator or proceed to www.mutualofomaha.com/eoi to fill out an EOI.</p>
        </GridColumn>
      </GridRow>
    </Grid>
  </Modal>
}